<template>
  <div class="tab-content">
    <div class="pagenamPT">
      <h3 class="pagename2">{{ $t('front.common.dailyUser') }}</h3>
      <date-filter-Pt :startDate="startDate"
                      :endDate="endDate"
                      @update="updateDate"
                      @search="loadList" />
    </div>
    <article class="content-wrap">
      <div class="strTablescr">
        <div class="strTablePC">
          <table class="statTable">
            <thead>
              <tr>
                <th>{{ $t('front.common.partnerID') }}</th>
                <th>{{ $t('front.common.userID') }}</th>
                <th>{{ $t('front.common.nickName') }}</th>
                <th class="text-right">{{ $t('front.stributor.m22') }}</th>
                <th class="text-right">{{ $t('front.stributor.m23') }}</th>
                <th class="text-right">{{ $t('front.cash.charge') }}</th>
                <th class="text-right">{{ $t('front.cash.exchange') }}</th>
                <th class="text-right">{{ $t('front.cash.coupon') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="dailyUserList && dailyUserList.length > 0">
                <tr v-for="item in dailyUserList" :key="item.memId">
                  <td>{{ item.upperId }}</td>
                  <td>{{ item.memId }}</td>
                  <td>{{ item.memNick }}</td>
                  <td class="text-right">{{ thousand(item.dBetAmt || 0) }}</td>
                  <td class="text-right">{{ thousand(item.dWinAmt || 0) }}</td>
                  <td class="text-right">{{ thousand(item.dUserCashIn || 0) }}</td>
                  <td class="text-right">{{ thousand(item.dUserCashOut || 0) }}</td>
                  <td class="text-right">{{ thousand(item.dCouponCash || 0) }}</td>
                </tr>
              </template>
              <template v-else>
                <tr><td colspan="8">{{ $t('front.common.notFoundList') }}</td></tr>
              </template>
            </tbody>
            <tfoot v-if="dailyUserSum">
              <tr>
                <td colspan="3">합계</td>
                <td class="text-right">{{ thousand(dailyUserSum.dBetAmt || 0) }}</td>
                <td class="text-right">{{ thousand(dailyUserSum.dWinAmt || 0) }}</td>
                <td class="text-right">{{ thousand(dailyUserSum.dUserCashIn || 0) }}</td>
                <td class="text-right">{{ thousand(dailyUserSum.dUserCashOut || 0) }}</td>
                <td class="text-right">{{ thousand(dailyUserSum.dCouponCash || 0) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <!-- <div class="strTableM">
          <div class="strTablePTM">
            <ul v-if="dailyUserSum" class="total">
              <li>합계</li>
              <li>{{ thousand(dailyUserSum.dBetAmt || 0) }}</li>
              <li>{{ thousand(dailyUserSum.dWinAmt || 0) }}</li>
              <li>{{ thousand(dailyUserSum.dUserCashIn || 0) }}</li>
              <li>{{ thousand(dailyUserSum.dUserCashOut || 0) }}</li>
              <li>{{ thousand(dailyUserSum.dCouponCash || 0) }}</li>
            </ul>
            <template v-if="dailyUserList && dailyUserList.length > 0">
              <template v-for="item in dailyUserList" :key="item.memId">
                <ul>
                  <li>
                    <em>{{ $t('front.common.partnerID') }}</em>
                    <div>{{ item.upperId }}</div>
                  </li>
                  <li>
                    <em>{{ $t('front.common.userID') }}</em>
                    <div>{{ item.memId }}</div>
                  </li>
                  <li>
                    <em>{{ $t('front.common.nickName') }}</em>
                    <div>{{ item.memNick }}</div>
                  </li>
                  <li>
                    <em>{{ $t('front.stributor.m22') }}</em>
                    <div>{{ thousand(item.dBetAmt || 0) }}</div>
                  </li>
                  <li>
                    <em>{{ $t('front.stributor.m23') }}</em>
                    <div>{{ thousand(item.dWinAmt || 0) }}</div>
                  </li>
                  <li>
                    <em>{{ $t('front.cash.charge') }}</em>
                    <div>{{ thousand(item.dUserCashIn || 0) }}</div>
                  </li>
                  <li>
                    <em>{{ $t('front.cash.exchange') }}</em>
                    <div>{{ thousand(item.dUserCashOut || 0) }}</div>
                  </li>
                  <li>
                    <em>{{ $t('front.cash.coupon') }}</em>
                    <div>{{ thousand(item.dCouponCash || 0) }}</div>
                  </li>
                </ul>
              </template>
            </template>
            <template v-else>
              <ul>
                <li>{{ $t('front.common.notFoundList') }}</li>
              </ul>
            </template>
          </div>
        </div> -->
      </div>
    </article>
  </div>
</template>
<script>
import DateFilterPt from '@/components/ui/DateFilterPt'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
import { mapState } from 'vuex'
import { getGameStaticsDailyUsersV2 } from '@/api/v2/statics'
export default {
  name: 'DateUsers',
  components: { DateFilterPt },
  data () {
    return {
      dailyUserList: null,
      dailyUserSum: null,
      startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
      endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')
    }
  },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ])
  },
  created () {
    this.loadList()
  },
  methods: {
    thousand,
    updateDate (value) {
      this.startDate = value.startDate
      this.endDate = value.endDate
    },
    loadList () {
      this.emitter.emit('Loading', true)
      this.dailyUserList = null
      this.dailyUserSum = null

      const params = {
        memId: this.userData.memId,
        startDate: this.startDate,
        endDate: this.endDate
      }
      getGameStaticsDailyUsersV2(params).then(res => {
        console.log('getGameStaticsDailyUsersV2 : ', params, res.data)
        const result = res.data
        if (result.resultCode === '0') {
          this.dailyUserList = result.data.dailyUserList
          this.dailyUserSum = result.data.dailyUserSum
          this.emitter.emit('Loading', false)
        } else {
          this.emitter.emit('Loading', false)
          alert('다시 시도해주세요. ', result.resultMessage)
        }
      })
    }
  }
}
</script>
<style src="@/styles/pt.css"></style>
<style scoped>
.tab-content {
  min-height: calc(100vh - 58px);
  background: #f4f7fb;
  box-sizing: border-box;
}

.pagenamPT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 18px;
}

.pagename2 {
  margin: 0;
  color: #0f172a;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.5px;
  line-height: 1.25;
}

/* 상단 날짜 검색 영역 */
.pagenamPT :deep(.datesearchPT),
.pagenamPT :deep(.datesearchPTWarp),
.pagenamPT :deep(.datesearch) {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 0 !important;
  margin: 0 !important;
  white-space: nowrap;
}

.pagenamPT :deep(input),
.pagenamPT :deep(select) {
  width: 138px !important;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #d7e0ec !important;
  border-radius: 7px !important;
  background: #fff !important;
  color: #1f2937 !important;
  box-sizing: border-box;
  font-size: 14px !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.pagenamPT :deep(input + input),
.pagenamPT :deep(input + .dateBtn),
.pagenamPT :deep(input + .bga) {
  margin-left: 8px !important;
}

.pagenamPT :deep(.dateBtn),
.pagenamPT :deep(.bga),
.pagenamPT :deep(button) {
  min-width: 54px !important;
  height: 40px !important;
  margin: 0 0 0 8px !important;
  padding: 0 14px !important;
  border: 1px solid #1d4ed8 !important;
  border-radius: 7px !important;
  background: #2563eb !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  line-height: 38px !important;
  box-shadow: 0 3px 8px rgba(37, 99, 235, 0.22);
  cursor: pointer;
}

.pagenamPT :deep(a) {
  cursor: pointer;
}

.content-wrap {
  overflow: hidden;
  background: #fff;
  border: 1px solid #dce5f2;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.045);
}

.strTablescr {
  width: 100%;
  overflow-x: auto;
  background: transparent !important;
  box-shadow: none !important;
}

.strTablePC {
  position: relative;
  min-width: 100%;
  overflow: hidden;
  border: 1px solid #dce5f2;
  border-top: 0;
  border-radius: 10px;
  background: #fff;
}

.strTablePC::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #2563eb;
  z-index: 2;
}

.statTable {
  width: 100%;
  min-width: 960px;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  table-layout: fixed;
}

.statTable th {
  height: 45px;
  padding: 3px 14px 0;
  background: #f6f9fd;
  border-bottom: 1px solid #dfe7f2;
  color: #1f2a3d;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}

.statTable td {
  height: 46px;
  padding: 0 14px;
  border-bottom: 1px solid #e8eef6;
  color: #1f2937;
  font-size: 14px;
  text-align: center;
  vertical-align: middle;
  line-height: 1.35;
}

.statTable tbody tr:nth-child(even) td {
  background: #fbfdff;
}

.statTable tbody tr:hover td {
  background: #f8fbff;
}

.statTable tbody tr:last-child td,
.statTable tfoot tr:last-child td {
  border-bottom: 0;
}

.statTable tfoot td {
  height: 48px;
  background: #edf5ff;
  border-top: 1px solid #cfe0ff;
  color: #0f4fd6;
  font-weight: 900;
}

.text-right {
  text-align: right !important;
  font-family: 'Roboto', sans-serif;
}

@media (max-width: 1000px) {
  .tab-content {
    padding: 16px 12px 30px;
  }

  .pagenamPT {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 14px;
  }

  .pagename2 {
    font-size: 19px;
  }

  .pagenamPT :deep(.datesearchPT),
  .pagenamPT :deep(.datesearchPTWarp),
  .pagenamPT :deep(.datesearch) {
    width: 100% !important;
    justify-content: flex-start !important;
    flex-wrap: wrap !important;
    gap: 6px !important;
  }

  .pagenamPT :deep(input),
  .pagenamPT :deep(select) {
    flex: 1 1 calc(50% - 34px);
    width: auto !important;
    min-width: 0 !important;
    height: 38px !important;
    font-size: 12px !important;
  }

  .pagenamPT :deep(.dateBtn),
  .pagenamPT :deep(.bga),
  .pagenamPT :deep(button) {
    flex: 0 0 54px;
    height: 38px !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 36px !important;
  }

  .content-wrap {
    padding: 10px;
    border-radius: 10px;
  }

  .statTable {
    min-width: 820px;
  }
}
</style>
